














import Vue from "vue";
export default Vue.extend({
  computed: {
    NolaPublishingUrl() {
      return `${process.env.VUE_APP_NOLA_PUBLISHING_URL}/existing-user`;
    },
  },
});
